export default __webpack_public_path__ + "static/media/comment.9bd6cb04.svg";